package org.example.project.service

import org.example.project.utils.All

const val YARD_SETTINGS_FILE = "yardsettings.json"
const val YARD_PDF_LOGO = "logo.yard.pdf"
const val YARD_PARKPLAETZE_BENUTZEN = "parkplaetzeImYardBenutzen"
const val YARD_PALETTENTAUSCH_WE_AKTIV = "palettentauschWeAktiv"
const val YARD_PALETTENTAUSCH_WA_AKTIV = "palettentauschWaAktiv"

object YardSettingsService {
    suspend fun load(): All {
        val settings = YardApi.loadYardSettings()?.withYardSettingsDefaults()
        if (settings != null) return settings
        return defaultSettings()
    }

    suspend fun save(settings: All): Boolean {
        return YardApi.saveYardSettings(settings.withYardSettingsDefaults()) != null
    }

    suspend fun parkplaetzeImYardBenutzen(): Boolean =
        load().yardSettingsBool(YARD_PARKPLAETZE_BENUTZEN, true)

    suspend fun logoForLayout(@Suppress("UNUSED_PARAMETER") layoutKey: String): String =
        load().logoSrc

    fun defaultSettings(): All =
        All(
            id = "yardsettings",
            key = "yardsettings",
            label = "Yard Settings",
            parkplaetzeImYardBenutzen = true,
            palettentauschWeAktiv = true,
            palettentauschWaAktiv = true
        )
}

fun All.withYardSettingsDefaults(): All =
    copy(
        id = id.ifBlank { "yardsettings" },
        key = key.ifBlank { "yardsettings" },
        label = label.ifBlank { "Yard Settings" }
    )

fun All.yardSettingsBool(key: String, fallback: Boolean): Boolean =
    when (key) {
        YARD_PARKPLAETZE_BENUTZEN -> parkplaetzeImYardBenutzen
        YARD_PALETTENTAUSCH_WE_AKTIV -> palettentauschWeAktiv
        YARD_PALETTENTAUSCH_WA_AKTIV -> palettentauschWaAktiv
        else -> fallback
    }
